import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dropdown } from "react-bootstrap";
import * as _ from "lodash";
import { tooltipate } from "../utils";
import { def } from "../../commons";
export const TableAction = ({ disabled = false, id, action, index, datum, keyField, onHandleAction, collapsed }) => {
    const component = _.isFunction(action.name) ? action.name(datum) : action.name;
    if (collapsed && def(action.collapsable, true)) {
        return (_jsx(Dropdown.Item, { eventKey: `${index}`, onClick: async (e) => {
                e.stopPropagation();
                await onHandleAction(id, datum, keyField, action);
            }, disabled: disabled, children: component }));
    }
    else {
        if (action.button) {
            const button = (_jsx(Button, { size: "sm", variant: "secondary", onClick: async (e) => {
                    e.stopPropagation();
                    await onHandleAction(id, datum, keyField, action);
                }, disabled: disabled, children: component }));
            return action.tooltip ? tooltipate(button, action.tooltip) : button;
        }
        else {
            if (action.items && action.items.length) {
                const dropdown = (_jsxs(Dropdown, { onClick: (e) => {
                        e.stopPropagation();
                    }, style: { display: "inline-block" }, className: "kpactions-parent xsmall", children: [_jsx(Dropdown.Toggle, { size: "sm", variant: "link", id: `dropdown-${Math.random() * 1000}`, className: "kpactions", disabled: disabled, children: component }), _jsx(Dropdown.Menu, { children: action.items.map((item, aindex) => (_jsx(Dropdown.Item, { onClick: async (e) => {
                                    e.stopPropagation();
                                    await onHandleAction(id, datum, keyField, action, item.value);
                                }, children: item.name }, aindex))) })] }));
                return action.tooltip ? tooltipate(dropdown, action.tooltip) : dropdown;
            }
            else {
                const button = (_jsx(Button, { variant: "link", className: "kpactions", onClick: async (e) => {
                        e.stopPropagation();
                        await onHandleAction(id, datum, keyField, action);
                    }, disabled: disabled, children: component }));
                return action.tooltip ? tooltipate(button, action.tooltip) : button;
            }
        }
    }
};
